import React, { useEffect, useMemo, useState } from 'react';
import { db } from '../firebase';
import {
  collection,
  getDocs,
  orderBy,
  limit,
  query,
  startAfter,
  where,
} from 'firebase/firestore';
import BookCard from '../components/BookCard';
import { getResponsivePageSize } from '../utils/pagination';
import { isReservationActive, listReservationsByBookIds } from '../utils/reservations';

const chunk = (arr, size = 10) => {
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

export default function PopularPage() {
  const pageSize = getResponsivePageSize();
  const [items, setItems] = useState([]);
  const [lastDoc, setLastDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [onlyAvailable, setOnlyAvailable] = useState(true); // показувати лише доступні

  const loadPage = async (isFirst) => {
    if (isFirst) setLoading(true); else setLoadingMore(true);

    try {
      const baseRef = collection(db, 'bookTemplates');

      // Сортуємо за популярністю; беремо порціями
      let q = query(baseRef, orderBy('borrowCount', 'desc'), limit(pageSize));
      if (!isFirst && lastDoc) {
        q = query(baseRef, orderBy('borrowCount', 'desc'), startAfter(lastDoc), limit(pageSize));
      }

      const snap = await getDocs(q);
      const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));

      const tplIds = docs.map((d) => d.id).filter(Boolean);
      const books = [];
      for (const pack of chunk(tplIds, 10)) {
        const s = await getDocs(
          query(
            collection(db, 'books'),
            where('status', '==', 'available'),
            where('templateId', 'in', pack)
          )
        );
        books.push(...s.docs.map((d) => ({ id: d.id, ...d.data() })));
      }
      const reservations = await listReservationsByBookIds(books.map((b) => b.id));
      const reservedBookIds = new Set(
        reservations.filter((r) => isReservationActive(r)).map((r) => String(r.bookId || r.id))
      );
      const freeByTpl = new Map();
      books.forEach((b) => {
        if (reservedBookIds.has(String(b.id))) return;
        const t = String(b.templateId || '');
        if (!t) return;
        freeByTpl.set(t, (freeByTpl.get(t) || 0) + 1);
      });
      const normalized = docs.map((d) => ({ ...d, __freeCount: freeByTpl.get(String(d.id)) || 0 }));

      setItems(prev => isFirst ? normalized : [...prev, ...normalized]);
      setLastDoc(snap.docs[snap.docs.length - 1] || null);
      setHasMore(snap.docs.length === pageSize);
    } finally {
      if (isFirst) setLoading(false); else setLoadingMore(false);
    }
  };

  useEffect(() => { loadPage(true); }, []);
  const [winW, setWinW] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  useEffect(() => {
    const onResize = () => setWinW(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const cols =
    winW <= 540 ? 'repeat(2, minmax(0,1fr))' :
    winW <= 900 ? 'repeat(3, minmax(0,1fr))' :
                  'repeat(4, minmax(0,1fr))';


  const visible = useMemo(() => {
    if (!onlyAvailable) return items;
    return items.filter(x => (x.__freeCount ?? 0) > 0);
  }, [items, onlyAvailable]);

  return (
    <div style={{ background: '#F6F4EF', minHeight: '100vh' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '16px 12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <h1 style={{ margin: 0 }}>Популярні книги</h1>

          <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 14, color: '#374151' }}>
            <input
              type="checkbox"
              checked={onlyAvailable}
              onChange={(e) => setOnlyAvailable(e.target.checked)}
            />
            Показувати лише доступні
          </label>
        </div>

        {loading ? (
          <div>Завантаження…</div>
        ) : visible.length === 0 ? (
          <div>Книг не знайдено.</div>
        ) : (
          <>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: cols,
                gap: 16,
              }}
            >
              {visible.map(tpl => (
                <BookCard key={tpl.id} tpl={tpl} />
              ))}
            </div>

            {hasMore && (
              <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0 8px' }}>
                <button
                  onClick={() => loadPage(false)}
                  disabled={loadingMore}
                  style={{
                    padding: '10px 16px',
                    borderRadius: 10,
                    border: '1px solid #0b5226',
                    background: '#0b5226',
                    color: '#fff',
                    fontWeight: 700,
                    cursor: 'pointer',
                  }}
                >
                  {loadingMore ? 'Завантаження…' : 'Показати ще'}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}



